<template>
  <Transition name="dialog">
    <div
      v-if="show"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-6"
      @click.self="handleSkip"
    >
      <div class="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        <!-- Icon -->
        <div class="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center text-3xl">
          💾
        </div>

        <!-- 標題 -->
        <h3 class="text-lg font-bold text-textMain mb-3 text-center">資料備份說明</h3>

        <!-- 內容 -->
        <p class="text-sm text-textMuted leading-relaxed mb-6 text-center">
          目前使用匿名方式安全儲存資料。<br>
          建立帳號後，可在換手機或多裝置時找回資料。
        </p>

        <!-- 按鈕 -->
        <div class="space-y-3">
          <button
            @click="handleCreateAccount"
            class="w-full py-3 rounded-xl font-bold text-white bg-primary active:scale-95 transition-all"
          >
            建立帳號
          </button>
          <button
            @click="handleLogin"
            class="w-full py-3 rounded-xl font-bold text-primary bg-primary/10 active:scale-95 transition-all"
          >
            已有帳號？登入
          </button>
          <button
            @click="handleSkip"
            class="w-full py-3 rounded-xl font-bold text-textMuted bg-gray-100 active:scale-95 transition-all"
          >
            了解，維持匿名使用
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
interface Props {
  show: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  createAccount: []
  login: []
  skip: []
}>()

const handleCreateAccount = () => {
  emit('createAccount')
}

const handleLogin = () => {
  emit('login')
}

const handleSkip = () => {
  emit('skip')
}
</script>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoom-in-95 {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

.animate-in {
  animation: fade-in 0.2s ease, zoom-in-95 0.2s ease;
}
</style>
